<template>
  <div id="Custom">
    <!-- <NelFundTop v-show="!this.$store.state.webview" /> -->
    <b-navbar toggleable="lg" type="light" variant="light">
      <router-link class="navbar-brand text-muted" :to="{ name: 'HomeCustom' }">
        <span><img alt="NelFund Logo" src="../assets/nelfund-icon.png" height="50"/></span>
        <span>Custom</span>
      </router-link>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <li class="nav-item">
            <router-link :to="{ name: 'HomeCustom' }" class="nav-link">
              <b-icon-house></b-icon-house>
              Home
            </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'TicketsCustom2', params: { status: 'escalated' } }" class="nav-link">
              <b-icon-circle-fill class="text-warning"></b-icon-circle-fill>
              Escalated
            </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'TicketsCustom2', params: { status: 'closed' } }" class="nav-link">
              <b-icon-circle-fill class="text-success"></b-icon-circle-fill>
              Closed
            </router-link>
          </li>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <notifications />
          <b-nav-item-dropdown right>
            <template #button-content> <b-icon-person-circle></b-icon-person-circle> {{ authUser.Name }} </template>

            <b-dropdown-item :to="{ name: 'ProfileCustom' }">
              <b-icon-person></b-icon-person>
              Profile
            </b-dropdown-item>

            <Logout kind="list" />
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <div style="margin-top: 20px; width: 100%; height: auto;">
      <router-view />
    </div>
  </div>
</template>

<script>
import NelFundTop from '@/components/NelFundTop.vue'
import Logout from '@/components/Logout.vue'
import Notifications from '../components/Notifications.vue'

export default {
  name: 'CustomLayout',

  components: {
    NelFundTop,
    Logout,
    Notifications
  },

  computed: {
    authUser() {
      return this.$store.state.authUser
    },

    year() {
      let d = new Date()
      return d.getFullYear()
    }
  }
}
</script>
